export const isDesktop = (): boolean => {
  if (typeof window !== 'undefined') {
    const userAgent = window.navigator.userAgent.toLowerCase()
    const isMobile = /mobile|android|iphone|ipad|tablet/i.test(userAgent)
    return !isMobile
  }
  return false
}
